import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle } from '@material-ui/core';
import {
  Button, Select, Input, Label,
} from '@ipc/ipc-components';
import { CreateThresholdDialogStyles } from './CreateThresholdDialog.styles';

function ThresholdCreateDialog(props) {
  const {
    isOpen,
    closeDialog,
    onSave,
    elementList,
    dataList,
  } = props;
  const handleCancel = () => {
    closeDialog();
  };
  const [element, setElement] = useState(null);
  const [contactGroup, setContactGroup] = useState(null);
  const [threshold, setThreshold] = useState(null);
  const [isFormValid, setFromValidity] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const elementsRestrictions = {
    FLIGHT_SCHEDULE_THRESHOLD: ['MRD'],
    ACTUAL_FLIGHT_TIME_THRESHOLD: ['MRD'],
    HANDOVER_DATA_DROP_THRESHOLD: ['DATA_SHARING'],
  };
  const targetGroupCodeOptions = {
    MRD: ['IPC', 'MRD'],
    DATA_SHARING_OUTBOUND: ['IPC', 'DATA_SHARING'],
    DATA_SHARING_INBOUND: ['IPC', 'DATA_SHARING'],
  };
  const [contactGroupOptions, setContactGroupOptions] = useState(['MRD', 'DATA_SHARING', 'IPC'].map((key) => ({ label: key, value: key })));

  useEffect(() => {
    if (element !== null) {
      const targetCode = targetGroupCodeOptions[elementList.find((item) => item.name === element.label).targetGroupCode];
      const options = targetCode.filter((item) => (elementsRestrictions[element.label] ? !elementsRestrictions[element.label].includes(item) : true)).map((key) => ({ label: key, value: key }));
      setContactGroupOptions(options);
    }
  }, [element]);
  useEffect(() => {
    if (contactGroup !== null && !contactGroupOptions.find((item) => item.value === contactGroup.value)) {
      setContactGroup(null);
    }
  }, [contactGroupOptions]);

  useEffect(() => {
    const isValid = !(!element?.value || threshold === null || !contactGroup?.value);
    const duplicateRecord = dataList.find((item) => item.name === element?.label && item.contactGroup === contactGroup?.label && item.value === Number(threshold));
    if (duplicateRecord) {
      setIsDuplicate(true);
    } else if (isDuplicate) {
      setIsDuplicate(false);
    }
    setFromValidity(isValid);
  }, [element, threshold, contactGroup]);

  const onElementChange = (selection) => {
    setElement(selection);
  };
  const onContactGroupChange = (selection) => {
    setContactGroup(selection);
  };

  const elementOptions = elementList.map((item) => ({ label: item.name, value: item.id }));

  const thresholdKeyPress = (e) => {
    const phoneRegex = /[0-9\d\s-+/()\\\][]/g;
    if (!phoneRegex.test(e.key)) {
      e.preventDefault();
    }
  };
  const handleThreshold = (e) => {
    if (e.target.value === '') {
      setThreshold(null);
    } else {
      setThreshold(e.target.value);
    }
  };
  const confirmSave = () => {
    const params = {
      contactGroupCode: contactGroup.value,
      elementId: element.value,
      value: threshold,
    };
    onSave(params);
  };

  return (
    <Dialog onClose={handleCancel} aria-labelledby="simple-dialog-title" open={isOpen}>
      <CreateThresholdDialogStyles>
        <DialogTitle id="simple-dialog-title">New Threshold</DialogTitle>
        <div className="table-container">
          <table className="threshold-form-details">
            <tbody>
              <tr>
                <td className="threshold-form-input-details">
                  <Label>Element</Label>
                </td>
                <td className="threshold-form-input-details">
                  <Select
                    autoWidth
                    value={element?.value}
                    placeholder={element?.label}
                    options={elementOptions}
                    onChange={onElementChange}
                  />
                </td>
              </tr>
              <tr>
                <td className="threshold-form-input-details">
                  <Label>Notification ContactGroup</Label>
                </td>
                <td className="threshold-form-input-details">
                  <Select
                    autoWidth
                    value={contactGroup?.value || null}
                    placeholder={contactGroup?.label || 'Select...'}
                    options={contactGroupOptions}
                    onChange={onContactGroupChange}
                  />
                </td>
              </tr>
              <tr>
                <td className="threshold-form-input-details">
                  <Label>Threshold (hours)</Label>
                </td>
                <td className="threshold-form-input-details">
                  <Input
                    type="tel"
                    value={threshold}
                    maxLength={3}
                    size={5}
                    onChange={handleThreshold}
                    onKeyPress={(e) => thresholdKeyPress(e)}
                  />
                </td>
              </tr>
              {isDuplicate && (
                <tr>
                  <td />
                  <td className="contact-form-input-details error-message" style={{ color: 'red' }}>There is an active threshold record with same details</td>
                </tr>
              )}

            </tbody>
          </table>
        </div>
        <div className="after-box">
          <Button className="cancel" onClick={handleCancel}>Cancel</Button>
          <Button
            className={`primary-button-${!isFormValid || isDuplicate} action`}
            disabled={!isFormValid || isDuplicate}
            id="save"
            onClick={confirmSave}
          >
            Save
          </Button>
        </div>
      </CreateThresholdDialogStyles>
    </Dialog>
  );
}
ThresholdCreateDialog.propTypes = {
  isOpen: PropTypes.bool,
  closeDialog: PropTypes.func,
  onSave: PropTypes.func,
  elementList: PropTypes.arrayOf(PropTypes.any),
  dataList: PropTypes.arrayOf(PropTypes.any),
};
export default ThresholdCreateDialog;
